module.exports = __webpack_public_path__ + "7b9568e6389b1f8ae0902cd39665fc1e.svg";